import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Confirm = ({
  color = colors.grey90,
  height = 16,
  isColorInherited = false,
  width = 16,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M3.3264 11.8643L2.113 9.47995C1.92818 9.11677 2.07277 8.67253 2.43595 8.48771C2.79913 8.3029 3.24337 8.44749 3.42818 8.81066L4.64262 11.1971C4.65567 11.2229 4.67489 11.2457 4.69826 11.2627C4.72163 11.2797 4.74871 11.291 4.77727 11.2955C4.80583 11.3 4.83505 11.2976 4.86253 11.2886C4.89 11.2796 4.91494 11.2642 4.93529 11.2437L4.93653 11.2424L12.7069 3.44368C12.9945 3.15501 13.4617 3.15416 13.7504 3.44178C14.039 3.7294 14.0399 4.19658 13.7523 4.48525L5.98344 12.2824M3.3264 11.8643C3.44495 12.0984 3.61744 12.3011 3.82954 12.4556C4.04192 12.6103 4.28802 12.7123 4.54756 12.7532C4.8071 12.7941 5.07264 12.7727 5.3223 12.6908C5.57162 12.6091 5.79878 12.4684 5.98344 12.2824"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
